export default "__VITE_ASSET__35bWbUd9__"